// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jzon from "rescript-jzon/lib/es6/src/Jzon.bs.mjs";
import * as LumiDate from "lumi-rescript/lib/es6/src/LumiDate.bs.mjs";
import * as LumiJzon from "lumi-rescript/lib/es6/src/LumiJzon.bs.mjs";
import * as LumiRequest from "lumi-rescript/lib/es6/src/LumiRequest.bs.mjs";
import * as Types$LumiDocuments from "lumi-documents/lib/es6/src/Types.bs.mjs";

var jsonCodec = Jzon.object7((function (param) {
        return [
                param.id,
                param.facilityName,
                param.time,
                param.totalPlaces,
                param.freePlaces,
                param.occupiedPlaces,
                param.message
              ];
      }), (function (param) {
        return {
                TAG: "Ok",
                _0: {
                  id: param[0],
                  facilityName: param[1],
                  time: param[2],
                  totalPlaces: param[3],
                  freePlaces: param[4],
                  occupiedPlaces: param[5],
                  message: param[6]
                }
              };
      }), Jzon.field("id", Jzon.string), Jzon.field("facilityName", Jzon.string), Jzon.field("time", LumiDate.DateTime.jsonCodec), Jzon.field("totalPlaces", Jzon.$$int), Jzon.field("freePlaces", Jzon.$$int), Jzon.field("occupiedPlaces", Jzon.$$int), Jzon.field("message", Jzon.string));

var FacilityParkingCounts = {
  jsonCodec: jsonCodec
};

var jsonCodec$1 = Jzon.object8((function (param) {
        return [
                param.id,
                param.time,
                param.name,
                param.totalPlaces,
                param.latitude,
                param.longitude,
                param.address,
                param.openingTimes
              ];
      }), (function (param) {
        return {
                TAG: "Ok",
                _0: {
                  id: param[0],
                  time: param[1],
                  name: param[2],
                  totalPlaces: param[3],
                  latitude: param[4],
                  longitude: param[5],
                  address: param[6],
                  openingTimes: param[7]
                }
              };
      }), Jzon.field("id", Jzon.string), Jzon.field("time", LumiDate.DateTime.jsonCodec), Jzon.field("name", Jzon.string), Jzon.field("totalPlaces", Jzon.$$int), Jzon.field("latitude", Jzon.string), Jzon.field("longitude", Jzon.string), Jzon.field("address", Jzon.string), Jzon.field("openingTimes", Jzon.array(LumiJzon.tuple2(LumiDate.DateTime.jsonCodec, Types$LumiDocuments.OpenClosedState.jsonCodec))));

var FacilityInfo = {
  jsonCodec: jsonCodec$1
};

function getParkingCount(organisation) {
  return LumiRequest.expectJSON(LumiRequest.make("/api/3/parkingcount/" + organisation, "GET", undefined, undefined, undefined), Jzon.array(jsonCodec));
}

function getFacilityInfo(organisation) {
  return LumiRequest.expectJSON(LumiRequest.make("/api/3/facility-info/" + organisation, "GET", undefined, undefined, undefined), Jzon.array(jsonCodec$1));
}

var V3 = {
  FacilityParkingCounts: FacilityParkingCounts,
  FacilityInfo: FacilityInfo,
  getParkingCount: getParkingCount,
  getFacilityInfo: getFacilityInfo
};

export {
  V3 ,
}
/* jsonCodec Not a pure module */
